import Joi from 'joi';

/**
 * Schema for capture payment request validation.
 */
export const capturePaymentSchema = () =>
  Joi.object({
    paymentId: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|payment-id|cannot-be-null',
        }),
        otherwise: Joi.number().integer().required().messages({
          'any.required': 'validations|payment-id|required',
          'number.base': 'validations|payment-id|must-be-number',
        }),
      })
      .required()
      .messages({
        'any.required': 'validations|payment-id|required',
      }),
  }).unknown(true);
